import { createContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, useParams } from "react-router-dom";
import Footer from "../components/Footer";
import Header from "../components/Header";
import Loader from "../components/Modals/Loader";
import Modal from "../components/Modals/Modal";
import api from "../storage/api";
import { cartActions } from "../storage/cart";
import { modalActions } from "../storage/modals";

const AppContext = createContext({
  serverLogo: "",
  serverSlug: "",
});

const RootLayout = () => {
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.modals.loading);
  const isModal = useSelector((state) => state.modals.show);
  const params = useParams();

  document.body.removeAttribute("class");

  const [siteContent, setSiteContent] = useState({
    ip: "",
    vk_link: "",
    discord_link: "",
    tiktok_link: "",
    youtube_link: "",
    contact_email: "",
    logo: "",
  });

  useEffect(() => {
    const loadCommonData = async () => {
      dispatch(modalActions.showLoadingModal());
      const response = await fetch(`${api.apiPath}&path=info&server=${params.server}`);

      if (!response.ok) {
        console.log("error loading common data");
        return;
      }

      const payload = await response.json();

      setSiteContent(payload);

      dispatch(modalActions.hideAllModals());
      dispatch(cartActions.setServer(payload.id));

      if (payload.styles) {
        const link = document.createElement("link");
        link.type = "text/css";
        link.rel = "stylesheet";
        link.href = `${api.apiImages}${payload.styles}`;
        document.head.appendChild(link);
      }
    };

    loadCommonData();
  }, [dispatch, params.server]);

  useEffect(() => {
    const loadPromocodes = async () => {
      dispatch(modalActions.showLoadingModal());
      const response = await fetch(`${api.apiPath}&path=promocodes&server=${params.server}`);

      if (!response.ok) {
        console.log("error loading common data");
        return;
      }

      const payload = await response.json();

      if (payload.length > 0) {
        dispatch(modalActions.showPromocodesModal(payload));
      }
    };

    loadPromocodes();
  }, [dispatch, params.server]);

  return (
    <AppContext.Provider value={{ serverLogo: siteContent.logo, serverSlug: params.server }}>
      {isLoading && <Loader />}
      <Header siteContent={siteContent} />
      <Outlet />
      {isModal && <Modal />}
      <Footer siteContent={siteContent} />
    </AppContext.Provider>
  );
};

export { AppContext };
export default RootLayout;
